<div class="container pb-50 pt-20" id="school-calendar">
  <div class="row mt-20">
    <div class="col-md-8 col-lg-8">
      <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <button class="nav-link active" (click)="resetCalendarOnEvent()" id="nav-calender-tab" data-bs-toggle="tab"
            data-bs-target="#nav-calender" type="button" role="tab" aria-controls="nav-calender" aria-selected="true"
            (click)="setActiveTab(true)">
            Calendar
          </button>
          <button class="nav-link" (click)="getCalenderBookings()" id="nav-bookings_cal-tab" data-bs-toggle="tab"
            data-bs-target="#nav-bookings_cal" type="button" role="tab" aria-controls="nav-bookings_cal"
            aria-selected="false" (click)="setActiveTab(false)">
            Bookings
          </button>
        </div>
      </nav>
      @if (availability_check) {
      <div class="col-lg-12 col-md-12 col-sm-12 mt-10">
        <app-quick-availability-update (availabilityUpdated)="refreshCalendar()"
          [stats]="sideComponentData"></app-quick-availability-update>
      </div>
      }
      @if(isContractTeacher){
      <div class="row">
        <div class="col-md-12 mt-20">
          <div class="alert alert-blue d-flex align-items-center custom-alert" role="alert">
            <span><strong>Note:</strong> You can only set casual availability on days when you're not scheduled for
              LRT/DRT work.</span>
          </div>
        </div>
      </div>
      }
      <div class="tab-content mt-20" id="nav-tabContent">
        <div class="tab-pane fade show active" id="nav-calender" role="tabpanel" aria-labelledby="nav-calender-tab">
          <div class="row">
            <div class="col-lg-12 col-md-12">
              <div class="row mt-5 mb-20 align-items-center">
                <div class="col-lg-12">
                  <button (click)="openRecurringUpdateModal()"
                    class="cc-blue-btn float-right fs-14 pl-20 pr-20">Recurring update</button>
                </div>
              </div>
              <full-calendar [options]="calendarOptions" #calendar></full-calendar>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="nav-bookings_cal" role="tabpanel" aria-labelledby="nav-bookings_cal-tab">
          <form [formGroup]="calendarBookingFilterForm">
            <div class="row align-items-center mt-10">
              <div class="col-lg-6 col-md-6 mt-10 form-floating">
                <label for="search_by_name" id="search_by_name_label">Search by school name</label>
                <div class="">
                  <input id="name" id="search_by_name" ariaLabel="Search by school name"
                    aria-labelledby="search_by_name_label" formControlName="school" type="text" class="form-control"
                    (change)="getCalenderBookings()" />
                </div>
              </div>
              <div class="col-md-6 col-sm-6">
                <div class="form-floating left-labeled mt-10">
                  <input type="text" placeholder="Select date" class="form-control" bsDatepicker [bsConfig]="{
                      dateInputFormat: 'DD/MM/YYYY',
                      containerClass: 'theme-red',
                      showWeekNumbers: false,
                      adaptivePosition: true,
                    }" [daysDisabled]="[6, 0]" [(ngModel)]="bsValue" (ngModelChange)="getCalenderBookings()"
                    [ngModelOptions]="{ standalone: true }" />
                  <label for="floatingSelect">Select date</label>
                </div>
              </div>
            </div>
          </form>
          @if (bookingTabDetails?.length > 0) {
          <div>
            <div>
              <div>
                @for (item of bookingTabDetails; track $index) {
                <h3 class="mt-20">{{ item.date | date: 'MMM, d' }}</h3>
                @for (list of item.booking; track $index) {
                <div class="card mt-10 px-18" [ngClass]="list.status == 'Cancelled' ? 'cancelled_teacher one_day' : ''"
                  appFocus appClick type="button">
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-12">
                      <div class="col-md-12 col-lg-12 d-flex">
                        <div class="pic-and-check c_input"></div>
                        <div class="pic-and-check ml-0">
                          <img
                            [src]="list.booking.school?.profile_image || '/../../../assets/images/teacher-static-profile.png'"
                            class="profile-picture-l img-complete-match" />
                        </div>
                        <div class="pic-and-check ml-10">
                          <div class="d-flex">
                            <a role="button">
                              <span class="user-title c-p h_b">{{ list.booking.school?.title }}</span>
                              @if(list?.booking?.strategy === 'PRE'){
                              <span class="bg-tags-custom fit-content ml-10">Pre confirmed</span>
                              }
                              @if (list.status == 'Cancelled') {
                              <span class="one_day_cancelled_teacher ms-3">2hr pay</span>
                              }
                            </a>
                          </div>
                          <p class="txt-regular">
                            {{ list?.booking?.school?.address?.address_timezone?.state }}
                          </p>
                          <p class="txt-regular">
                            <i class="bi bi-calendar-event fs-13 mr-2"></i>
                            {{ list.display_date }}
                          </p>
                          <p class="txt-regular mt-5">
                            <i class="bi bi-clock fs-13 mr-2"></i>
                            {{ list.start_time }} -
                            {{ list.end_time }}
                          </p>
                          <p class="mb-0 lh-12">
                            <span class="text-s-m-g-3 mr-4">Class being covered:</span>
                            <span class="user-sub-title">{{ list?.information?.class_being_covered }}</span>
                          </p>
                          <p class="mb-0 lh-12">
                            <span class="text-s-m-g-3 mr-4">Teacher being covered:</span>
                            <span class="user-sub-title">{{ list?.information?.provider_being_covered }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                }
                }
              </div>
            </div>
          </div>
          }
          @if (bookingTabDetails.length == 0) {
          <div class="text-center mt-20">
            <p>
              <img class="no-invite-image" src="assets/images/CCPI_PendingRequests_NoAcceptedRequests-021.png"
                alt="No invites found!" />
            </p>
            <p class="title">No bookings found.</p>
          </div>
          }
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-4">
      @if (selectedDates.length == 0) {
      <div class="card px-16">
        <div class="row">
          <div class="col-md-6">
            <div class="text-center">
              <p class="text-regular-bold">Total bookings ({{ current_month }})</p>
              <p class="text-regular fs-18 mt-5">
                {{ stats?.monthly_booking_count }}
              </p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <p class="text-regular-bold">Hours booked ({{ current_month }})</p>
              <p class="text-regular fs-18 mt-5">
                {{ stats?.total_booking_hours }}
              </p>
            </div>
          </div>
          <div class="col-md-6 mt-20">
            <div class="text-center">
              <p class="text-regular-bold">Available days</p>
              <p class="text-regular fs-18 mt-5">
                {{ stats?.availabile_days }}
              </p>
            </div>
          </div>
          <div class="col-md-6 mt-20">
            <div class="text-center">
              <p class="text-regular-bold">Unavailable days</p>
              <p class="text-regular fs-18 mt-5">
                {{ stats?.unavailable_days }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <h6 class="user-title mb-0 mt-20">My Bookings</h6>

      <h6 class="text-regular-medium mt-10">{{ showSideDate }}</h6>
      @if (this.bookingList.length === 0) {
      <div class="card px-15 mt-15 d-flex flex-row align-items-center">
        <div class="d-flex align-items-center">
          <img alt="img" class="img-fluid" style="max-width: 80px;" src="assets/PendingInvites_NoHistoryFound.png" />
          <h5 class="user-title-m mb-0 mt-3 ml-10">
            You have no bookings for the selected date.
          </h5>
        </div>
      </div>
      } @else if (this.bookingList.length > 0) {
      @if (showHalfDayBookings) {
      <div class="card mt-10 px-15">
        <p class="txt-regular">
          {{ whichHalfDayBookings }} :
          <span class="text-regular-bold clr-cc-vilot">{{ this.halfDayIndicated[0].status }}</span>
        </p>
        <form [formGroup]="updateAvailabilityForm">
          <div class="row">
            <div class="col-md-12 col-sm-12 col-lg-12 mt-15 form-floating">
              <label id="verification_status" for="no_of_staff">Availability</label>
              <select class="form-select" formControlName="availability" aria-label="Verified teacher list"
                (change)="onAvailabilityChangeHalf($event, halfDayIndicated[0])">
                <option value="available">Available</option>
                <option value="unavailable">Unavailable</option>
                <option value="booked_externally">Booked Externally</option>
              </select>
            </div>
          </div>
        </form>
      </div>
      }
      @for (item of bookingList; track $index) {
      <div (click)="showPopupForEvent(item)" class="card mt-10 px-15"
        [ngClass]="item.status == 'Cancelled' ? 'cancelled_teacher one_day' : ''" appFocus appClick type="button">
        <div class="row">
          <div [ngClass]="item.status == 'Cancelled' ? 'col-lg-9 col-md-9 col-9' : 'col-lg-12 col-md-12 col-12'">
            <div class="d-flex">
              <div class="pic-and-check c_input"></div>
              <div class="pic-and-check ml-0">
                <img [src]="item.booking?.school?.profile_image || '/../../../assets/images/teacher-static-profile.png'"
                  class="profile-picture-s img-complete-match" />
              </div>
              <div class="pic-and-check ml-10">
                <p class="txt-regular">
                  <span>
                    {{ item.display_date }}
                  </span>
                  <span class="divider-right ml-2 mr-4"></span>
                  <span>
                    {{ item.start_time }} - {{ item.end_time }}
                  </span>
                </p>
                <div class="d-flex">
                  <a role="button">
                    <span class="user-title c-p h_b">{{ item.booking?.school?.title }}</span>
                  </a>
                </div>
                <p class="mb-0 lh-12">
                  <span class="text-s-m-g-3 mr-4">Class being covered:</span>
                  <span class="user-sub-title">{{ item?.information?.class_being_covered }}</span>
                </p>
              </div>
            </div>
          </div>
          @if (item.status == 'Cancelled') {
          <div class="col-lg-3 col-md-3">
            <span class="teacher_booking_cancel_txt">Cancelled</span>
            <span class="one_day_cancelled_teacher">2hr pay</span>
          </div>
          }
        </div>
      </div>
      }
      }
      }
      @if(!availability_check){
      <div class="col-lg-12 col-md-12 col-sm-12 mt-10">
        <app-quick-availability-update (availabilityUpdated)="refreshCalendar()"
          [stats]="sideComponentData"></app-quick-availability-update>
      </div>
      }
      @if (lrtDrtSelectedDates.length > 0) {
      <div class="card px-16">
        <div class="d-flex justify-content-between align-items-center mb-10">
          <h6 class="user-title mb-0">LRT / DRT Availability Changes</h6>
          <a class="text-regular-medium clr-cc-vilot float-right c-p" (click)="removeAllSelectedDatesLrtDrt()">Clear
            all</a>
        </div>
        <div [class.lrt-dates-scroll]="selectedDates.length > 5">
        @for (date of selectedDates; track date) {
        @if (getLrtDrtDayRows(date); as lrtDrtDayRows) {
        <div class="lrt-date-card">
          <div class="lrt-date-card__header">
            <span class="lrt-date-card__date">{{ date | date: 'dd/MM/yyyy' }}</span>
            <span class="c-p lrt-date-card__remove" (click)="removeSelectedDate(date, '')">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" stroke-width="1.5" stroke="#9E9E9E"
                fill="#9E9E9E" class="bi bi-x-lg" viewBox="0 0 16 20">
                <path
                  d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
              </svg>
            </span>
          </div>

          @for (row of lrtDrtDayRows; track row.label) {
          <div class="lrt-half-row">
            <span class="lrt-half-row__label">{{ row.label }}</span>
            <span class="lrt-half-row__badge" [ngClass]="getStatusBadgeClass(row.statusLabel)">{{ row.statusLabel }}</span>

            @if (row.isContract) {
            <span class="lrt-half-row__locked">Reserved - Unavailable</span>
            } @else {
            <select class="form-select fs-13" name="availability{{ date }}"
              [value]="individualAvailability[date].availability"
              (change)="onIndividualAvailabilityChange(date, 'availability', $event)">
              <option value="available">Available</option>
              <option value="unavailable">Unavailable</option>
              <option value="booked_externally">Booked Externally</option>
            </select>
            }

            @if (lrtDrtDayRows.length > 1) {
            <span class="c-p lrt-half-row__remove" (click)="removeLrtDrtHalfDay(date, row.halfValue)">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" stroke-width="1.5" stroke="#9E9E9E"
                fill="#9E9E9E" class="bi bi-x-lg" viewBox="0 0 16 20">
                <path
                  d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
              </svg>
            </span>
            }
          </div>
          }
        </div>
        }
        }
        </div>
        @if(schoolProps.properties.is_qld_teacher){
        <div class="col-lg-12 col-12">
          <div class="card px-15 mt-10">
            <p class="txt-regular">Apply for your leave by following this link to the employee self service platform.
            </p>
            <a role="button" class="c-p clr-cc-vilot text-regular-bold mt-10" target="_blank"
              href="https://myhr-ess.qed.qld.gov.au/" appFocus appClick aria-label="Add External Events">Apply for a
              leave<i class="bi bi-arrow-right ms-1"></i></a>
          </div>
        </div>
        }
        <button class="cc-blue-btn fs-12 mt-20 w-100" (click)="updateAvailabilityIndividual()">Update LRT/DRT
          availability</button>
      </div>
      }
      @if (roasterUnavailableSelectedDates.length > 0) {
      <div class="card px-16">
        <div class="d-flex justify-content-between align-items-center mb-10">
          <h6 class="user-title mb-0">Revert contract days</h6>
          <a class="text-regular-medium clr-cc-vilot float-right c-p" (click)="removeAllSelectedDatesLrtDrt()">Clear
            all</a>
        </div>
        <p class="txt-regular fs-13">
          {{roasterUnavailableSelectedDates.length}} {{roasterUnavailableSelectedDates.length > 0 ? 'days' : 'day'}}
          selected. These will be reverted from <b>Unavailable</b> back to <b>Contract day</b>.
        </p>
        <div [class.lrt-dates-scroll]="selectedDates.length > 5">
        @for (date of selectedDates; track date) {
        @if (getRoasterUnavailableDayRows(date); as roasterDayRows) {
        <div class="lrt-date-card">
          <div class="lrt-date-card__header">
            <span class="lrt-date-card__date">{{ date | date: 'dd/MM/yyyy' }}</span>
            <span class="c-p lrt-date-card__remove" (click)="removeSelectedDate(date, '')">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" stroke-width="1.5" stroke="#9E9E9E"
                fill="#9E9E9E" class="bi bi-x-lg" viewBox="0 0 16 20">
                <path
                  d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
              </svg>
            </span>
          </div>

          @for (row of roasterDayRows; track row.label) {
          <div class="lrt-half-row">
            <span class="lrt-half-row__label">{{ row.label }}</span>
            <span class="lrt-half-row__badge" [ngClass]="getStatusBadgeClass(row.statusLabel)">{{ row.statusLabel }}</span>

            @if (row.isRoasterUnavailable) {
            <span class="lrt-half-row__locked">Reserved - Revert back</span>
            } @else {
            <select class="form-select fs-13" name="availability{{ date }}"
              [value]="individualAvailability[date].availability"
              (change)="onIndividualAvailabilityChange(date, 'availability', $event)">
              <option value="available">Available</option>
              <option value="unavailable">Unavailable</option>
              <option value="booked_externally">Booked Externally</option>
            </select>

            <!-- Show these only if booked_externally for this date -->
            @if (individualAvailability[date].availability === 'booked_externally') {
            <input type="text" class="form-control fs-13"
              [value]="individualAvailability[date].external_school"
              (input)="onIndividualAvailabilityChange(date, 'external_school', $event)"
              placeholder="School name" />
            <input type="text" class="form-control fs-13"
              [value]="individualAvailability[date].external_contact"
              (input)="onIndividualAvailabilityChange(date, 'external_contact', $event)"
              placeholder="School contact" />
            }
            }

            @if (roasterDayRows.length > 1) {
            <span class="c-p lrt-half-row__remove" (click)="removeRoasterUnavailableHalfDay(date, row.halfValue)">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" stroke-width="1.5" stroke="#9E9E9E"
                fill="#9E9E9E" class="bi bi-x-lg" viewBox="0 0 16 20">
                <path
                  d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
              </svg>
            </span>
            }
          </div>
          }
        </div>
        }
        }
        </div>
        <button class="cc-blue-btn fs-12 mt-20 w-100" (click)="updateAvailabilityIndividual()">Update LRT/DRT
          availability</button>
      </div>
      }
      @if (selectedDates.length > 0) {
      <div class="card px-16" *ngIf="lrtDrtSelectedDates.length == 0 && roasterUnavailableSelectedDates.length == 0">
        <div class="d-flex justify-content-between align-items-center">
          <h6 class="user-title mb-0">Mark availability</h6>
          <a class="text-regular-medium clr-cc-vilot float-right c-p" (click)="removeAllSelectedDates()">Clear all</a>
        </div>
        <nav>
          <div class="nav nav-tabs fs-12 mt-15" id="nav-tab" role="tablist">
            <button class="nav-link active fs-14" id="nav-selectedDate-tab" data-bs-toggle="tab"
              data-bs-target="#nav-selectedDate" type="button" role="tab" aria-controls="nav-selectedDate"
              aria-selected="true" (click)="setSubActiveTab('selected')">
              Selected dates
            </button>
            <button class="nav-link fs-14" id="nav-individualBookings-tab" data-bs-toggle="tab"
              data-bs-target="#nav-individualBookings" type="button" role="tab" aria-controls="nav-individualBookings"
              aria-selected="false" (click)="setSubActiveTab('individual')">
              Individual dates
            </button>
          </div>
        </nav>
        <div class="tab-content mt-10" id="nav-tabContent">
          <div class="tab-pane fade show active" id="nav-selectedDate" role="tabpanel"
            aria-labelledby="nav-selectedDate-tab">
            <div class="d-flex flex-wrap">
              @for (date of selectedDates; track date) {
              <div class="card selectedDateCard">
                <p class="text-regular-bold">
                  {{ date | date: 'dd/MM/yyyy' }}

                  <span class="c-p" (click)="removeSelectedDate(date, '')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" stroke-width="1.5" stroke="#9E9E9E"
                      fill="#9E9E9E" class="bi bi-x-lg" viewBox="0 0 16 20">
                      <path
                        d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg>
                  </span>
                </p>
              </div>
              }
            </div>
            <form [formGroup]="updateAvailabilityForm">
              <div class="row">
                <div class="col-md-6 col-sm-6 col-lg-6 mt-15 form-floating">
                  <label id="verification_status" for="no_of_staff">Availability</label>
                  <select class="form-select" formControlName="availability" aria-label="Verified teacher list"
                    (change)="onAvailabilityChange($event)">
                    <option value="available">Available</option>
                    <option value="unavailable">Unavailable</option>
                    <option value="booked_externally">Booked Externally</option>
                  </select>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-6 mt-15 form-floating">
                  <label id="verification_status" for="no_of_staff">Time commitment</label>
                  <select class="form-select" formControlName="time" aria-label="Verified teacher list">
                    <option value="full-day">Full day</option>
                    <option value="half-day-am">Half day AM</option>
                    <option value="half-day-pm">Half day PM</option>
                  </select>
                </div>
                @if (isBookedExternally) {
                <div class="col-lg-12 col-md-12 col-sm-12 mt-15 form-floating">
                  <label for="search_by_school_name" id="search_by_school_name_label">School name</label>
                  <div class="d-flex">
                    <input id="school_name" aria-label="Search by school name"
                      aria-labelledby="search_by_school_name_label" formControlName="external_school" type="text"
                      class="form-control" />
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 mt-15 form-floating">
                  <label for="search_by_school_contact" id="search_by_school_contact_label">School contact</label>
                  <div class="d-flex">
                    <input id="search_by_school_contact" aria-label="Search by school contact"
                      aria-labelledby="search_by_school_contact_label" formControlName="external_contact" type="text"
                      class="form-control" />
                  </div>
                </div>
                }
              </div>
            </form>
            <button (click)="updateAvailability('selected_dates')" class="cc-blue-btn fs-12 mt-10 w-100">Update
              availability</button>
          </div>
          <div class="tab-pane fade" id="nav-individualBookings" role="tabpanel"
            aria-labelledby="nav-individualBookings-tab">
            @for (date of selectedDates; track date) {
            <div class="d-flex flex-wrap individual_select">
              <div class="card selectedDateCardIndi width_availability">
                <p class="text-regular-bold">
                  {{ date | date: 'dd/MM/yyyy' }}
                  <span class="c-p date-close float-right" (click)="removeSelectedDate(date, '')">
                    <!-- SVG for remove -->
                    <span class="c-p" (click)="removeSelectedDate(date, '')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" stroke-width="1.5" stroke="#9E9E9E"
                        fill="#9E9E9E" class="bi bi-x-lg" viewBox="0 0 16 20">
                        <path
                          d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                      </svg>
                    </span>
                  </span>
                </p>
              </div>
              <div class="width_availability_1">
                <select class="form-select fs-13 mt-8" [value]="individualAvailability[date].availability"
                  (change)="onIndividualAvailabilityChange(date, 'availability', $event)">
                  <option value="available">Available</option>
                  <option value="unavailable">Unavailable</option>
                  <option value="booked_externally">Booked Externally</option>
                </select>
              </div>
              <div class="width_availability_2">
                <select class="form-select mt-8 fs-13" [value]="individualAvailability[date].time"
                  (change)="onIndividualAvailabilityChange(date, 'time', $event)">
                  <option value="full-day">Full day</option>
                  <option value="half-day-am">Half day AM</option>
                  <option value="half-day-pm">Half day PM</option>
                </select>
              </div>
              <!-- Show these only if booked_externally for this date -->
              @if (individualAvailability[date].availability === 'booked_externally') {
              <div class="width_availability_3">
                <input type="text" class="form-control mt-8 fs-13"
                  [value]="individualAvailability[date].external_school"
                  (input)="onIndividualAvailabilityChange(date, 'external_school', $event)" placeholder="School name" />
              </div>
              <div class="width_availability_3">
                <input type="text" class="form-control mt-8 fs-13"
                  [value]="individualAvailability[date].external_contact"
                  (input)="onIndividualAvailabilityChange(date, 'external_contact', $event)"
                  placeholder="School contact" />
              </div>
              }
            </div>
            <hr class="mb-0" />
            }

            <!-- @for( date of selectedDates; track date) {
              <form [formGroup]="updateAvailabilityIndividualForm">
                <div class="d-flex flex-wrap individual_select">
                  <div class="card selectedDateCardIndi width_availability">
                    <p class="text-regular-bold">
                      {{ date | date : "dd/MM/yyyy" }}

                      <span class="c-p" (click)="removeSelectedDate(date, '')">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="15"
                          stroke-width="1.5"
                          stroke="#9E9E9E"
                          fill="#9E9E9E"
                          class="bi bi-x-lg"
                          viewBox="0 0 16 20"
                        >
                          <path
                            d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"
                          />
                        </svg>
                      </span>
                    </p>
                  </div>

                  <div class="width_availability_1">
                    <select
                      class="form-select fs-13 mt-8"
                      formControlName="availability"
                      aria-label="Verified teacher list"
                    >
                      <option value="available">Available</option>
                      <option value="unavailable">Unavailable</option>
                      <option value="booked_externally">Booked Externally</option>
                    </select>
                  </div>
                  <div class="width_availability_2">
                    <select
                      class="form-select mt-8 fs-13"
                      formControlName="time"
                      aria-label="Verified teacher list"
                    >
                      <option value="full-day">Full day</option>
                      <option value="half-day-am">Half day AM</option>
                      <option value="half-day-pm">Half day PM</option>
                    </select>
                  </div>
                  <div class="width_availability_3">
                    <input
                      type="text"
                      class="form-control mt-8 fs-13"
                      formControlName="external_school"
                      placeholder="School name"
                    />
                  </div>
                  <div class="width_availability_3">
                    <input
                      type="text"
                      class="form-control mt-8 fs-13"
                      formControlName="external_contact"
                      placeholder="School contact"
                    />
                  </div>
                </div>
              </form>
              } -->
            <button (click)="updateAvailabilityIndividual()" class="cc-blue-btn fs-12 mt-10 w-100">Update
              availability</button>
          </div>
        </div>
      </div>
      @if (this.bookingList.length > 0) {
      @for (item of bookingList; track $index) {
      <h6 class="user-title mb-0 mt-20">My Bookings</h6>
      <h6 class="text-regular-medium mt-10">{{ showSideDate }}</h6>
      <div class="card mt-10 px-18" [ngClass]="item.status == 'Cancelled' ? 'cancelled_teacher one_day' : ''" appFocus
        appClick type="button">
        <div class="row">
          <div [ngClass]="item.status == 'Cancelled' ? 'col-lg-9 col-md-9 col-9' : 'col-lg-12 col-md-12 col-12'">
            <div class="d-flex">
              <div class="pic-and-check c_input"></div>
              <div class="pic-and-check ml-0">
                <img [src]="item.booking?.school?.profile_image || '/../../../assets/images/teacher-static-profile.png'"
                  class="profile-picture-s img-complete-match" />
              </div>
              <div class="pic-and-check ml-10">
                <div class="d-flex">
                  <a role="button">
                    <span class="user-title c-p h_b">{{ item.booking?.school?.title }}</span>
                  </a>
                </div>
                <!-- <p class="user-sub-title">09/10/2023</p> -->
                <p class="mb-0 lh-12">
                  <span class="text-s-m-g-3 mr-4">Class being covered:</span>
                  <span class="user-sub-title">{{ item?.information?.class_being_covered }}</span>
                </p>
              </div>
            </div>
          </div>
          @if (item.status == 'Cancelled') {
          <div class="col-lg-3 col-md-3 col-2">
            <span class="teacher_booking_cancel_txt">Cancelled</span>
            <span class="one_day_cancelled_teacher">2hr pay</span>
          </div>
          }
        </div>
      </div>
      }
      }
      }
    </div>
  </div>

  <!-- Bulk Edit -->
  <div class="modal fade" bsModal #bulkEdit="bs-modal" tabindex="-1" role="dialog"
    aria-labelledby="dialog-nested-name1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title pull-left">Edit Booking</h4>
          <button type="button" class="btn-close close pull-right" aria-label="Close"
            (click)="bulkEdit.hide(); closeBulkModal()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h6>Edit or delete an individual booking or a series of bookings</h6>
          <form [formGroup]="getBulkDataForm">
            <div class="row mt-20">
              <div class="col-lg-4">
                <div class="input-group">
                  <input id="search-by-name" formControlName="filter_name" type="text" placeholder="Search by name"
                    class="form-control" aria-label="Search by name" />
                  <button class="input-group-text" (click)="getBulkEditData('')" for="search-by-name">
                    <i class="bi bi-search"></i>
                  </button>
                </div>
              </div>
              <div class="col-lg-4">
                <input type="text" [minDate]="minDate" [(ngModel)]="bsBulkFromValue"
                  [ngModelOptions]="{ standalone: true }" (ngModelChange)="getBulkEditData($event)"
                  placeholder="From date" class="form-control" bsDatepicker [bsConfig]="{
                    dateInputFormat: 'DD/MM/YYYY',
                    containerClass: 'theme-red',
                    showWeekNumbers: false,
                  }" />
              </div>
              <div class="col-lg-4">
                <input type="text" [minDate]="minDate" [(ngModel)]="bsBulkToValue"
                  [ngModelOptions]="{ standalone: true }" (ngModelChange)="getBulkEditData($event)"
                  placeholder="To date" class="form-control" bsDatepicker [bsConfig]="{
                    dateInputFormat: 'DD/MM/YYYY',
                    containerClass: 'theme-red',
                    showWeekNumbers: false,
                  }" />
              </div>
            </div>
          </form>
          <div class="row mt-8">
            @if (bulkData) {
            <div class="col-lg-12">
              @if (bulkData.length > 0) {
              <table class="table">
                <thead class="cardThead">
                  <tr>
                    <th scope="col">
                      <input #checkAllApp [(ngModel)]="selectAllAppCheck" class="form-check-input mt-0 mr-5"
                        id="checkAllApp" type="checkbox" (change)="selectAllApp('All', $event)" />
                    </th>
                    <th class="u_m_s_g2" scope="col">Casual booked</th>
                    <th class="u_m_s_g2" scope="col">Date</th>
                    <th class="u_m_s_g2" scope="col">Class being covered</th>
                    <th class="u_m_s_g2" scope="col">Teacher being covered</th>
                  </tr>
                </thead>
                <tbody>
                  @for (data of bulkData; track data) {
                  <tr>
                    <td scope="row">
                      <input class="form-check-input mr-10 c-p" (change)="selectAllApp(data, $event)"
                        [checked]="data.isChecked"
                        [disabled]="!data.is_classroomteacher_booking_check && this.classroomLimited" type="checkbox"
                        id="{{ data.id }}" type="checkbox" />
                    </td>
                    <td class="txt-regular mt-1">
                      <img class="cal_pp"
                        [src]="data.profile_image != null ? data.profile_image : '../../../../assets/images/teacher-static-profile.png'" />
                      <span class="ml-10">{{ data.full_name }}</span>
                    </td>
                    <td class="u_m_s_g2 mt-1">
                      {{ data.date }}
                      <br />
                      {{ data.time }}
                    </td>
                    <td class="u_m_s_g2">{{ data.class_covered }}</td>
                    <td class="u_m_s_g2">{{ data.teacher_covered }}</td>
                  </tr>
                  }
                </tbody>
              </table>
              }
              @if (bulkData.length == 0) {
              <div>
                <p class="text-center mt-10">
                  <img class="no-bulkData" src="assets/images/CCPI_PendingRequests_NoAcceptedRequests-02.png"
                    alt="No_img" />
                </p>
                <h6 class="text-center title mt-20">Enter a staff name or a date range to be able to edit a booking or
                  multiple bookings</h6>
              </div>
              }
            </div>
            }
            @if (!bulkData) {
            <div>
              <p class="text-center mt-10">
                <img class="no-bulkData" src="assets/images/CCPI_PendingRequests_NoAcceptedRequests-02.png"
                  alt="No_img" />
              </p>
              <h6 class="text-center title mt-20">Enter a staff name or a date range to be able to edit a booking or
                multiple bookings</h6>
            </div>
            }
            <div class="col-lg-12 mt-20">
              <div class="row">
                <div class="col-md-12 d-flex justify-content-end">
                  <button [ngClass]="this.bulkDetails.length > 0 ? '' : 'disabled'"
                    (click)="openBulkDeleteModal(); bulkEdit.hide()" class="btn-plain-txt mr-30" id="delete">
                    Delete
                    @if (this.bulkDetails.length > 0) {
                    <span>{{ this.bulkDetails.length }} bookings</span>
                    }
                  </button>
                  <button [ngClass]="this.bulkDetails.length > 0 ? '' : 'disabled'"
                    (click)="openBulkDetailModal(); bulkEdit.hide()" type="submit" class="btn cc_p_btn fs_14">Edit
                    Booking</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #bulkDataModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Update booking</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeBulkEditModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="editBookings">
      <div class="row">
        <div class="col-md-12">
          <p class="txt-regular">Booking request edits will need to be reviewed and confirmed by staff that are
            involved. You can edit your booking up until the day of your booking.</p>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-md-6 mt-10">
          <input type="text" class="form-control" formControlName="booking_teachercovered"
            placeholder="{{ filtersArray.custom_field2 }}" />
        </div>
        <div class="col-md-6 mt-10">
          <input type="text" class="form-control" formControlName="booking_classcovered"
            placeholder="{{ filtersArray.custom_field1 }}" />
        </div>
        <div class="col-md-6 mt-10">
          <select class="form-select" formControlName="booking_absencereason" aria-label="booking-absence-reason">
            @for (absense of filtersArray.absence_reason; track absense) {
            <option value="{{ absense.value }}">
              {{ absense.title }}
            </option>
            }
          </select>
        </div>
        <!-- <div class="col-md-12  mt-10">
                      <textarea type="text" class="form-control" formControlName="booking_notes" rows="3"
                      placeholder="This note will be sent to the staff via email"></textarea>
                    </div> -->

        <div class="col-md-6 mt-10">
          <input type="text" class="form-control" formControlName="booking_payrollfield1"
            placeholder="{{ filtersArray.payroll_report_fields?.payroll_field_label_1 }}" />
        </div>
        <div class="col-md-6 mt-10">
          <input type="text" class="form-control" formControlName="booking_payrollfield2"
            placeholder="{{ filtersArray.payroll_report_fields?.payroll_field_label_2 }}" />
        </div>
        <div class="col-md-6 mt-10">
          <input type="text" class="form-control" formControlName="booking_payrollfield3"
            placeholder="{{ filtersArray.payroll_report_fields?.payroll_field_label_3 }}" />
        </div>
      </div>

      <div class="col-lg-12 mt-20">
        <div class="row">
          <div class="col-md-12 d-flex justify-content-end">
            <!-- <button class="btn-plain-txt mr-30  " id="delete">
                              Cancel
                            </button> -->
            <button (click)="openBulkConfrimModal()" type="submit" class="btn cc_p_btn fs_14">Update</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #updateAvailabilityModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Update availability?</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeAvailConfirmModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="editBookings">
      <div class="row">
        <div class="col-md-12">
          <p class="txt-regular">Are you sure you want to update your availability?</p>
        </div>
      </div>
      <div class="col-lg-12 mt-20">
        <div class="row">
          <div class="col-md-12 d-flex justify-content-end">
            <!-- <button class="btn-plain-txt mr-30  " id="delete">
                            Cancel
                          </button> -->
            <button (click)="updateAvailabilityAPI(updateType)" type="submit"
              class="btn cc_p_btn fs_14">Confirm</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #recurringUpdateModal>
  @if (!showAvailabilityModal) {
  <div class="modal-header">
    <h4 class="modal-title pull-left">Recurring update</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeConfirmModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="recurringUpdateForm">
      <div class="row">
        @if(isContractTeacher){
        <div class="col-md-12 mt-20">
          <div class="alert alert-warning d-flex align-items-center custom-alert" role="alert">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-info-circle me-2" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
              <path
                d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
            </svg>
            <span>Contract dates will not be included in Recurring update</span>
          </div>
        </div>
        }
        <div class="col-md-6 col-sm-6">
          <div class="form-floating left-labeled mt-10">
            <input type="text" placeholder="Select date" class="form-control" bsDatepicker [minDate]="minDate"
              [maxDate]="maxDate" formControlName="start_date" [bsConfig]="{
                  dateInputFormat: 'DD/MM/YYYY',
                  containerClass: 'theme-red',
                  showWeekNumbers: false,
                  adaptivePosition: true,
                }" [daysDisabled]="[6, 0]" />
            <label for="floatingSelect">Start on</label>
          </div>
        </div>
        <div class="col-md-6 col-sm-6 col-lg-6 mt-15 form-floating">
          <label id="verification_status" for="no_of_staff">Repeat every</label>
          <select class="form-select" formControlName="recurrent_week" aria-label="Verified teacher list">
            <option value="1">1 week</option>
            <option value="2">2 weeks</option>
          </select>
        </div>
        <div class="col-md-12 col-sm-12 ends_in">
          <div class="repeat_inTab mt-10">
            <label class="pl-10 r_label">Repeat on</label>
            <div class="form-floating">
              <div class="form-check">
                <input class="form-check-input" checked [checked]="checked(1)" (change)="onChange($event, 1)"
                  type="checkbox" id="repeat_tuesday" />
                <label class="form-check-label" for="repeat_tuesday">M</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" [checked]="checked(2)" (change)="onChange($event, 2)" type="checkbox"
                  id="repeat_tuesday" />
                <label class="form-check-label" for="repeat_tuesday">T</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" [checked]="checked(3)" (change)="onChange($event, 3)" type="checkbox"
                  value="3" id="repeat_wednesday" />
                <label class="form-check-label" for="repeat_wednesday">W</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" [checked]="checked(4)" (change)="onChange($event, 4)" type="checkbox"
                  value="4" id="repeat_thursday" />
                <label class="form-check-label" for="repeat_thursday">Th</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" [checked]="checked(5)" (change)="onChange($event, 5)" type="checkbox"
                  value="5" id="repeat_friday" />
                <label class="form-check-label" for="repeat_friday">F</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-10">
        <div class="col-md-6 col-sm-6">
          <div class="d-flex gap-2">
            <input type="radio" name="occurrence_type" formControlName="occurrence_type" value="0" id="blue_tick"
              class="form-check-input c-p mt-10" />
            <!-- <label for="blue_tick" class="form-check-label c-p">
              Blue tick
            </label> -->

            <div class="form-floating left-labeled mt-10 w-100">
              <input type="text" placeholder="Select date" class="form-control" bsDatepicker [minDate]="minDate"
                [maxDate]="maxDate" formControlName="end_date" [bsConfig]="{
                    dateInputFormat: 'DD/MM/YYYY',
                    containerClass: 'theme-red',
                    showWeekNumbers: false,
                    adaptivePosition: true,
                  }" [daysDisabled]="[6, 0]" />
              <label for="floatingSelect">Ends on</label>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6">
          <div class="d-flex gap-2">
            <div class="form-check">
              <input name="occurrence_type" formControlName="occurrence_type" type="radio" value="1" id="green_tick"
                class="form-check-input c-p mt-10" />
            </div>
            <div class="form-floating left-labeled mt-10 w-100">
              <input type="number" formControlName="occurrence" class="form-control" id="occurrences" />
              <label for="occurrences">Occurrences</label>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-6 col-sm-6 ends_in">
          <div class="date-input-container">
            <div class="left-section">
              <input type="radio" id="endDate" name="dateOption" />
              <label for="endDate">
                <span class="title">Occurrences</span>
                <input type="text" class="form-control" />
              </label>
            </div>
          </div>
        </div> -->
      </div>

      <div class="col-lg-12 mt-20">
        <div class="row">
          <div class="col-md-12 d-flex justify-content-end">
            <button (click)="recurringDatesMatch()" type="submit" class="btn cc_p_btn fs_14">Review</button>
          </div>
        </div>
      </div>
    </form>
  </div>
  } @else if (showAvailabilityModal) {
  <div class="modal-header">
    <h4 class="modal-title pull-left">Recurring update</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeConfirmModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="d-flex flex-wrap">
      @for (show_date of datesToShow; track show_date) {
      <div class="card selectedDateCard gap-2">
        <p class="text-regular-bold">
          {{ show_date.show_date | date: 'dd/MM/yyyy' }}

          <span class="c-p" (click)="removeSelectedDate(show_date.return_date, 'recurring')">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" stroke-width="1.5" stroke="#9E9E9E"
              fill="#9E9E9E" class="bi bi-x-lg" viewBox="0 0 16 20">
              <path
                d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
            </svg>
          </span>
        </p>
      </div>
      }
    </div>

    <form [formGroup]="updateAvailabilityForm">
      <div class="row">
        <div class="col-md-6 col-sm-6 col-lg-6 mt-15 form-floating">
          <label id="verification_status" for="no_of_staff">Availability</label>
          <select class="form-select" formControlName="availability" aria-label="Verified teacher list"
            (change)="onAvailabilityChange($event)">
            <option value="available">Available</option>
            <option value="unavailable">Unavailable</option>
            <option value="booked_externally">Booked Externally</option>
          </select>
        </div>
        <div class="col-md-6 col-sm-6 col-lg-6 mt-15 form-floating">
          <label id="verification_status" for="no_of_staff">Time commitment</label>
          <select class="form-select" formControlName="time" aria-label="Verified teacher list">
            <option value="full-day">Full day</option>
            <option value="half-day-am">Half day AM</option>
            <option value="half-day-pm">Half day PM</option>
          </select>
        </div>
        @if (isBookedExternally) {
        <div class="col-lg-12 col-md-12 col-sm-12 mt-15 form-floating">
          <label for="search_by_school_name" id="search_by_school_name_label">School name</label>
          <div class="d-flex">
            <input id="external_school" aria-label="Search by school name" aria-labelledby="search_by_school_name_label"
              formControlName="external_school" type="text" class="form-control" />
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 mt-15 form-floating">
          <label for="search_by_school_contact" id="search_by_school_contact_label">School contact</label>
          <div class="d-flex">
            <input id="search_by_school_contact" aria-label="Search by school contact"
              aria-labelledby="search_by_school_contact_label" formControlName="external_contact" type="text"
              class="form-control" />
          </div>
        </div>
        }
      </div>
    </form>
  </div>

  <div class="col-lg-12 mt-20">
    <div class="row">
      <div class="col-md-12 d-flex justify-content-end">
        <button (click)="backToRecurring()" class="btn-plain-txt mr-30" id="delete">Back to recurring</button>
        <button (click)="updateAvailability('recurring')" type="submit" class="btn cc_p_btn fs_14">Update
          availability</button>
      </div>
    </div>
  </div>
  }
</ng-template>

<ng-template #exportModal>
  <form [formGroup]="cancelBookingRequestForm">
    <div class="modal-header">
      <h4 class="modal-title" id="exampleModalLabel">Confirm export</h4>
      <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
    </div>

    <div class="modal-body pb-0">
      <div class="row align-items-center">
        <div class="col-md-12">
          <label>Enter date range to export bookings</label>
          <input formArrayName="export_bookings" placeholder="Enter date range" name="export_bookings"
            class="form-control mt-2" />

          <button type="button" (click)="updateBulkData('bulk_delete')" class="btn cc_p_btn fs_13 mt-10">Export</button>
        </div>
      </div>
    </div>
    <div class="modal-footer mt-10">
      <!-- <button type="button"  (click)="bsModalRef.hide()" class="btn_cc_back">Back</button> -->
      <button type="button" (click)="updateBulkData('bulk_delete')" class="btn cc_p_btn fs_13">Export</button>
    </div>
  </form>
</ng-template>

<ng-template #bookingExternalModal>
  <form [formGroup]="bookingExternalForm">
    <div class="modal-header">
      <h4 class="modal-title" id="exampleModalLabel">Update External Booking</h4>
      <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
    </div>

    <div class="modal-body pb-0">
      <div class="row align-items-center">
        <div class="col-md-12">
          <div class="d-flex justify-content-between">
            <div>
              <p class="user-title-m">Date</p>
              <p></p>
            </div>
            <div>
              <p class="user-title-m">Time Commitment</p>

              <p class="txt-regular">{{ timeCommitment }}</p>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <label>School name</label>
          <input formControlName="external_school" class="form-control mt-2" placeholder="Enter school name" />

          <label class="mt-3">School contact</label>
          <input formControlName="external_contact" class="form-control mt-2" placeholder="Enter school contact" />
        </div>
      </div>
    </div>
    <div class="modal-footer mt-10">
      <button type="button" (click)="deleteUpdateBooking()" class="btn btn-outline fs_13">Delete</button>
      <button type="button" (click)="updateExternalBookings()" class="btn cc_p_btn fs_13">Update</button>
    </div>
  </form>
</ng-template>
<ng-template #bookingsModal>
  @if (cancelBookingState) {
  <form [formGroup]="cancelBookingRequestForm">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">Confirm cancellation</h5>
      <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
    </div>

    <div class="modal-body pb-0">
      <div class="row align-items-center">
        @if (isOneDayBooking) {
        <div class="col-md-12 mt-20">
          <div class="alert alert-warning d-flex align-items-center custom-alert" role="alert">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-info-circle me-2" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
              <path
                d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
            </svg>
            <span>You are cancelling a booking within 24 hours</span>
          </div>
        </div>
        }
        <div class="col-12">
          <p class="popup-para-content mt-10">Are you sure you want to cancel this booking?</p>
          <!-- BLUE INFO BOX -->
          <div class="p-3 fs-14 border rounded grey-card-info mb-15 mt-4">
            <div class="d-flex flex-column">
              <p class="mb-5">
                <i class="bi bi-calendar-event fs-13 mr-4 text-r-g-3"></i>
                {{ bookingDatas.display_date }}
              </p>

              <p class="mb-5">
                <i class="bi bi-clock fs-13 mr-4 text-r-g-3"></i>
                {{ bookingDatas.start_time | startEndTime: 'hm' }} – {{ bookingDatas.end_time | startEndTime: 'hm' }}
              </p>

              <p class="mb-5">
                <span class="text-r-g-3">School:</span>
                {{ bookingDatas.booking.school.title }}
              </p>

              <!-- <p class="mb-0">
                <span class="text-r-g-3">Teacher:</span> {{bookingDatas.information.class_being_covered}}
              </p> -->
            </div>
          </div>
        </div>
        <p class="txt-regular" *ngIf="bookingDatas.booking.school.enable_cancellation">
          Let the school know why you're cancelling this booking
          <span class="show-errors">*</span>
        </p>
        <div class="col-md-12" *ngIf="bookingDatas.booking.school.enable_cancellation">
          <textarea class="form-control mt-5" formControlName="cancel_message" placeholder="Write here.."
            id="exampleFormControlTextarea1" rows="6"></textarea>
          @if (submitted) {
          <div>
            @if (cm['cancel_message'].errors?.['required']) {
            <span class="show-errors">* Cancel message is required</span>
            }
          </div>
          }
        </div>
        <div class="col-md-12 mt-10">
          <p class="user-title-m">Contact the school to inform them about your booking Cancellation</p>
          <p class="txt-regular">Emergency contact details of the school</p>
          <div class="d-flex mt-10">
            <div class="mr-20">
              <p class="txt-regular">
                <i class="bi bi-telephone clr-grey-7"></i>
                {{ bookingDatas.booking.school?.cancel_contact?.cancel_contact_phone_number }}
              </p>
            </div>
            <div>
              <p class="txt-regular envelope-icon">
                <i class="bi bi-envelope clr-grey-7"></i>
                {{ bookingDatas.booking.school?.cancel_contact?.cancel_contact_email }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer mt-10" *ngIf="bookingDatas.booking.school.enable_cancellation">
      <button type="button" (click)="cancelBooking(bookingDatas.line_item_id)"
        class="btn cc_p_btn fs_13">Confirm</button>
    </div>
  </form>
  } @else {
  <div class="">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">Booking information</h5>
      @if (bookingDatas.status == 'Cancelled') {
      <span class="teacher_booking_cancel_txt me-2 ms-2">(Cancelled)</span>
      <span class="one_day_cancelled_teacher">2hr pay</span>
      }
      <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <!-- {{ bookingDatas | json }} -->
      <div class="row mt-10">
        <div class="col-md-6 col-sm-6 col-lg-6">
          <div class="col-md-12 col-lg-12 d-flex">
            <div class="pic-and-check ml-0">
              <img alt="img"
                [src]="bookingDatas.booking.school.profile_image != null && bookingDatas.booking.school.profile_image != '' ? bookingDatas.booking.school.profile_image : '../../../../assets/images/teacher-static-profile.png'"
                class="profile-picture img-complete-match" />
            </div>
            <div class="pic-and-check ml-10">
              <div class="d-flex">
                <p>
                  <span class="user-title c-p">{{ bookingDatas.booking.school.title }}</span>
                </p>
              </div>
              <p class="txt-regular">
                <i class="bi bi-telephone-fill clr-grey-7 i-cc"></i>
                {{ bookingDatas.booking.school.phone_number }}
              </p>
              <p class="txt-regular envelope-icon">
                <i class="bi bi-envelope-fill clr-grey-7 i-cc"></i>
                {{ bookingDatas.booking.school.email }}
              </p>
            </div>
          </div>

          <div class="row mt-15">
            <p class="text-regular-medium">
              <i class="bi bi-calendar-event fs-13 mr-2 i-cc"></i>
              {{ bookingDatas.display_date }}
            </p>
            <p class="text-regular-medium mt-5">
              <i class="bi bi-clock fs-13 mr-2 i-cc"></i>
              {{ bookingDatas.start_time | startEndTime: 'hm' }} - {{ bookingDatas.end_time | startEndTime: 'hm' }}
            </p>
            <p class="text-regular-medium mt-5">
              <i class="bi bi-geo-alt-fill clr-grey-7 i-cc"></i>
              {{ bookingDatas.booking.school.address.address_timezone.state }}
            </p>
          </div>
          <div class="row">
            <div class="col-md-12 mt-10">
              <p>
                <span class="text-r-g-3">Class being covered:</span>
                <span class="txt-regular">
                  {{ bookingDatas.information.class_being_covered }}
                </span>
              </p>
            </div>
            <div class="col-md-12 mt-10">
              <p>
                <span class="text-r-g-3">Teacher being covered:</span>
                <span class="txt-regular">
                  {{ bookingDatas.information.provider_being_covered }}
                </span>
              </p>
            </div>
          </div>
          @if(schoolProps.properties.is_qld_teacher){
          <div class="row">
            <div class="col-md-12 mt-10">
              <p>
                <span class="text-r-g-3">Class plan title:</span>
                <span class="txt-regular">
                  {{ bookingDatas.information.attachment_title }}
                </span>
              </p>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 mt-10">
              <p>
                <span class="text-r-g-3">Class plan notes:</span>
                <span class="txt-regular">
                  {{ bookingDatas.information.notes }}
                </span>
              </p>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 mt-10">
              <span class="text-r-g-3">Class plan link:</span>
              <span class="txt-regular ml-5">
                <a href="{{ bookingDatas.information.details.attachment_link }}" target="_blank">{{
                  bookingDatas.information.details.attachment_link }}</a>
              </span>
            </div>
            <div class="col-md-12 mt-10">
              <span class="text-r-g-3">Class plan document:</span>
              <a href="{{ bookingDatas.information.file }}" target="_blank">
                {{ bookingDatas.information.file_name }}
              </a>
            </div>
          </div>
          }@else {
          <div class="row">
            <div class="col-md-12 mt-10">
              <p>
                <span class="text-r-g-3">Notes:</span><span class="txt-regular">
                  {{ bookingDatas.information.notes }}</span>
              </p>
            </div>
            <div class="col-md-12 mt-10">
              <span class="text-r-g-3">Attachments:</span>
              @if (bookingDatas.information.details.attachment_link != '' ||
              bookingDatas.information.details.attachment_link != 'null') {
              <span class="txt-regular ml-5">
                <a href="{{ bookingDatas.information.details.attachment_link }}" target="_blank">{{
                  bookingDatas.information.details.attachment_link }}</a>
              </span>
              } @if (bookingDatas.information.details.attachment_link == '' ||
              bookingDatas.information.details.attachment_link == 'null') {
              <a href="{{ bookingDatas.information.file }}" target="_blank">
                {{ bookingDatas.information.file }}</a>
              }
            </div>
          </div>
          }
        </div>
        <div class="col-md-6 col-sm-6 col-lg-6">
          <iframe width="100%" height="100%" frameborder="0" style="border: 0" [src]="googleMapsUrl"
            allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    @if (bookingDatas.status != 'Cancelled' && bookingDatas?.is_cancel_access && bookingDatas?.is_show_cancel_button) {
      <!-- {{bookingDatas?.is_cancel_access}} -->
      <button type="button" (click)="openCancelModal()" class="btn-outline h_b">Cancel booking</button>
    }
  </div>
  }
</ng-template>

<ng-template #cancelReasonModal>
  <form [formGroup]="cancelBookingRequestForm">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">Reason for cancellation</h5>
      <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
    </div>

    <div class="modal-body pb-0">
      <div class="row align-items-center">
        <p class="txt-regular" *ngIf="bookingDatas.booking.school.enable_cancellation">
          Let the school know why you're cancelling this booking
          <span class="show-errors">*</span>
          .
        </p>
        <div class="col-md-12" *ngIf="bookingDatas.booking.school.enable_cancellation">
          <textarea class="form-control mt-5" formControlName="cancel_message"
            placeholder="Notify the school of your need to cancel. (Mandatory)" id="exampleFormControlTextarea1"
            rows="6"></textarea>
          @if (submitted) {
          <div>
            @if (f['cancel_message'].errors?.['required']) {
            <span class="show-errors">* Cancel message is required</span>
            }
          </div>
          }
        </div>
        <div class="col-md-12 mt-10">
          <p class="user-title-m">Contact school to inform them about your booking Cancellation</p>
          <p class="txt-regular">Emergency contact details of the school</p>
          <div class="d-flex mt-10">
            <div class="mr-20">
              <p class="txt-regular">
                <i class="bi bi-telephone clr-grey-7"></i>
                {{ bookingDatas.booking.school?.cancel_contact?.cancel_contact_phone }}
              </p>
            </div>
            <div>
              <p class="txt-regular envelope-icon">
                <i class="bi bi-envelope clr-grey-7"></i>
                {{ bookingDatas.booking.school?.cancel_contact?.cancel_contact_email }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer mt-10" *ngIf="bookingDatas.booking.school.enable_cancellation">
      <button type="button" (click)="cancelBooking(bookingDatas.line_item_id)"
        class="btn cc_p_btn fs_13">Confirm</button>
    </div>
  </form>
</ng-template>